<ngx-loading-bar [includeSpinner]="false" color="#6989a9" />

@let options = routeOptions();

<div [class.layout]="options.showMenu" class="app pl-[var(--sidebar-width-small)] md:pl-0">
  @if (options.showMenu) {
    <tess-navigation [(closed)]="closedSidebar" />
  }

  <div class="main-layout" [class.closed-sidebar]="closedSidebar()">
    @if (options.showMenu) {
      <tess-toolbar />
    }

    <!-- I indicate that a route is being loaded asynchronously. -->
    @if (activeOutlet()) {
      <main [class.lazy-load-route-opacity]="options.asyncLoadCount" class="dark:bg-dark-900 dark:text-dark-100">
        <div [hidden]="activeOutlet() !== 'primary' ? 'until-found' : ''" class="h-full">
          <router-outlet (activate)="activateRouteOutlet()" (deactivate)="deactivateRouteOutlet()" />
        </div>

        <div [hidden]="activeOutlet() !== 'detail' ? 'until-found' : ''" [class.h-full]="activeOutlet() === 'detail'">
          <router-outlet name="detail" (activate)="activateRouteOutlet()" (deactivate)="deactivateRouteOutlet()" />
        </div>

        <div [hidden]="activeOutlet() !== 'subdetail' ? 'until-found' : ''" [class.h-full]="activeOutlet() === 'subdetail'">
          <router-outlet name="subdetail" (activate)="activateRouteOutlet()" (deactivate)="deactivateRouteOutlet()" />
        </div>

        <router-outlet name="quaternary" (activate)="activateRouteOutlet()" (deactivate)="deactivateRouteOutlet()" />
      </main>
    }
  </div>
</div>

<tess-overlay />

<!-- <tour-step-template></tour-step-template> -->
